import {
  FONT_STACK_BY_FAMILY,
  TENANT_FONT_CACHE_PREFIX,
  TENANT_FONT_LINK_ID,
  TENANT_FONT_STYLE_ID,
} from './constants';

const cacheKey = (hostname: string) => TENANT_FONT_CACHE_PREFIX + hostname;

function currentHost(): string {
  return typeof window === 'undefined' ? '' : window.location.hostname;
}

function ensureWebfont(googleFamily: string | undefined): void {
  document.getElementById(TENANT_FONT_LINK_ID)?.remove();
  if (!googleFamily) return;

  const link = document.createElement('link');
  link.id = TENANT_FONT_LINK_ID;
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(
    googleFamily,
  ).replace(/%20/g, '+')}:wght@400;500;600;700&display=swap`;
  document.head.appendChild(link);
}

export function applyTenantFont(family: string): void {
  if (typeof document === 'undefined') return;

  const font = FONT_STACK_BY_FAMILY[family];

  if (!font) return;

  ensureWebfont(font.googleFamily);

  const css = `body{font-family:${font.stack};}`;
  let style = document.getElementById(
    TENANT_FONT_STYLE_ID,
  ) as HTMLStyleElement | null;
  if (!style) {
    style = document.createElement('style');
    style.id = TENANT_FONT_STYLE_ID;
    document.head.appendChild(style);
  }
  if (style.textContent !== css) style.textContent = css;

  try {
    localStorage.setItem(cacheKey(currentHost()), family);
  } catch {
    // Storage unavailable; the next load just applies a moment later.
  }
}

/** Applies the last known typeface before React mounts, avoiding a reflow. */
export function bootTenantFont(): void {
  if (typeof window === 'undefined') return;
  try {
    const family = localStorage.getItem(cacheKey(currentHost()));
    if (family) applyTenantFont(family);
  } catch {
    /* empty */
  }
}
